export const Footer = () => {
  return (
    <footer className="border-t border-[#dce6f0] bg-[#f0f6fc]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="font-heading text-xl font-semibold text-[#2a3b5c] flex items-center gap-2">
            <span className="w-7 h-7 rounded-full bg-[#ffe89a] inline-flex items-center justify-center text-[#2a3b5c] text-sm font-semibold">
              K
            </span>
            Kenisha&#39;s Tutoring
          </div>
          <p className="mt-4 text-sm text-[#5c6b85] leading-relaxed max-w-sm">
            Friendly 1-to-1 science &amp; maths tuition for KS3, KS4 GCSE
            and A-Level Chemistry. Based in the UK, sessions delivered online.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-medium text-[#3d6fa8]">
            Sessions
          </div>
          <ul className="mt-4 space-y-2 text-sm text-[#5c6b85]">
            <li>Chemistry · KS3, KS4, A-Level</li>
            <li>Physics · KS3, KS4</li>
            <li>Biology · KS3, KS4</li>
            <li>Maths · KS3, KS4</li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-medium text-[#3d6fa8]">
            Get in touch
          </div>
          <ul className="mt-4 space-y-2 text-sm text-[#5c6b85]">
            <li>
              <a
                href="mailto:Kenishabossa@gmail.com"
                className="hover:text-[#3d6fa8] transition-colors"
              >
                Kenishabossa@gmail.com
              </a>
            </li>
            <li>£30 / hr KS3 &amp; KS4 · £40 / hr A-Level</li>
            <li>Mon – Sat · flexible times</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#dce6f0]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-6 text-xs text-[#5c6b85] flex flex-col md:flex-row gap-2 justify-between">
          <span>© {new Date().getFullYear()} Kenisha&#39;s Tutoring. All rights reserved.</span>
          <span>Made with care for curious minds.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
